/* eslint-disable react/jsx-no-target-blank */
import React from "react";
import "./Footer.scss";
import { Link } from "react-router-dom";
import { connect } from "react-redux";

import logo from "../../../assets/logo.png";
import instagram from "../../../assets/insta-icon.png";
import twitter from "../../../assets/twitter-icon.png";
import discord from "../../../assets/discord-icon.png";
import linkedin from "../../../assets/linkedin-icon.png";
import youtube from "../../../assets/youtube-icon.png";

const Footer = ({ darkmode, profile }) => {
  if ((darkmode = "dark")) {
    return (
      <div className="row footer-items-dark">
        <div className="col s12 m4 l4 " style={{ fontFamily: "inter" }}>
          <img src={logo} style={{ width: "150px" }} />
          <ul className="icons">
            <a target="_blank" href="https://www.instagram.com/vizcom_/">
              <li>
                <img src={instagram} style={{ width: "20px" }} /> Instagram
              </li>
            </a>
            <a target="_blank" href="https://twitter.com/Vizcom_co">
              <li>
                <img src={twitter} style={{ width: "20px" }} /> Twitter
              </li>
            </a>
            <a target="_blank" href="https://discord.gg/hRrbhMBq9x">
              <li>
                <img src={discord} style={{ width: "20px" }} />
                Discord
              </li>
            </a>
            <a target="_blank" href="https://www.linkedin.com/company/74908198">
              <li>
                <img src={linkedin} style={{ width: "20px" }} />
                Linkedin
              </li>
            </a>
            <li>
              <img src={youtube} style={{ width: "20px" }} />
              Youtube
            </li>
          </ul>
        </div>
        <div
          className="col s12 m4 l4 "
          style={{ color: "#111015", fontFamily: "inter" }}
        >
          <h1>Resources </h1>
          <ul className="icons">
            <a target="_blank" href="https://vizcom.medium.com/">
              <li>Blog</li>
            </a>
            <Link to="/privacy-policy">
              <li>Privacy</li>
            </Link>
            <Link to="/terms-of-use">
              <li>Terms of Use</li>
            </Link>
            <Link to="/about">
              <li>About us</li>
            </Link>
          </ul>
        </div>
        <div
          className="col s12 m4 l4 "
          style={{ color: "#111015", fontFamily: "inter" }}
        >
          <h1>Get started </h1>
          <ul className="icons">
            <Link to="/signin">
              <li>Login</li>
            </Link>
            <Link to="/signin">
              <li>Sign Up</li>
            </Link>
            <Link to="/pricing">
              <li>Pricing</li>
            </Link>
          </ul>
        </div>
      </div>
    );
  }
  if ((darkmode = "light")) {
    return (
      <div className="row footer-items">
        <div className="col s12 m12 l12 info">
          <ul>
            <Link to="/about">
              <li>About</li>
            </Link>
            <a target="_blank" href="https://discord.gg/hRrbhMBq9x">
              <li>Discord</li>
            </a>
            <a target="_blank" href="https://vizcom.medium.com/">
              <li>Blog</li>
            </a>
            <a target="_blank" href="https://twitter.com/Vizcom_co">
              <li>Twitter</li>
            </a>
            <a target="_blank" href="https://www.instagram.com/vizcom_/">
              <li>Instagram</li>
            </a>
            <Link to="/privacy-policy">
              <li>Privacy Policy</li>
            </Link>
            <Link to="/terms-of-use">
              <li>Terms of Use</li>
            </Link>
          </ul>
        </div>
      </div>
    );
  }
};

const mapStateToProps = (state) => {
  return {
    profile: state.profile.user,
  };
};

export default connect(mapStateToProps)(Footer);
